import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findWalletDeposit = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit?` + params,
        method: 'GET'
    })
}
export const findWalletDepositDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/downloadExcel?` + params,
        method: 'GET',
        timeout: 100*1000
    })
}

export const reject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/refuse?` + params,
        method: 'PUT'
    })
}
export const passToBank = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/passToBank?` + params,
        method: 'PUT'
    })
}
export const pass = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/pass?` + params,
        method: 'PUT'
    })
}

export const WxPass = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/pass/we_chat?` + params,
        method: 'PUT'
    })
}
export const depositSign = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/sign?` + params,
        method: 'PUT'
    })
}


export const WxRefuse = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/deposit/refuse?` + params,
        method: 'PUT'
    })
}